import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdReturns extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    fieldName: PropTypes.string.isRequired,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
    const val = props.shareclass[props.fieldName]
    this.state = {
      val,
      formattedVal: !val || val === -1000.0 ?
        '-' :
        (Math.round(val*100)/100.0).toFixed(2),
      red: typeof val === 'number' && val <= 0 && val !== -1000 ? 'red' : ''
    }
  }
  //
  render() {
    return <td
      styleName={'col-right ' + this.state.red}
      onClick={
        this.props.mobile ?
          () => { } :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      {this.state.formattedVal}
    </td>
  }
}
